var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Swap component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSwap extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.17902 5.30508L10.4659 8.6145C10.7578 8.9084 11.2327 8.91002 11.5266 8.61813C11.8205 8.32623 11.8221 7.85136 11.5302 7.55747L7.02124 3.01762C6.6884 2.68249 6.14617 2.68299 5.81395 3.01874L1.31552 7.56483C1.02417 7.85926 1.02667 8.33413 1.3211 8.62548C1.61554 8.91682 2.0904 8.91432 2.38175 8.61989L5.67902 5.28768L5.67896 20.4881C5.67895 20.9023 6.01474 21.2381 6.42895 21.2381C6.84317 21.2381 7.17895 20.9023 7.17896 20.4881L7.17902 5.30508Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.3294 18.6998L21.6163 15.3904C21.9082 15.0965 22.3831 15.0949 22.677 15.3868C22.9709 15.6786 22.9725 16.1535 22.6806 16.4474L18.1716 20.9873C17.8388 21.3224 17.2966 21.3219 16.9643 20.9861L12.4659 16.4401C12.1746 16.1456 12.1771 15.6708 12.4715 15.3794C12.7659 15.0881 13.2408 15.0906 13.5321 15.385L16.8294 18.7172L16.8293 3.51676C16.8293 3.10255 17.1651 2.76676 17.5793 2.76676C17.9936 2.76676 18.3293 3.10254 18.3293 3.51676L18.3294 18.6998Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSwap.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSwap.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSwap.prototype, "size", void 0);
if (customElements.get('cat-icon-swap') === undefined) {
    customElements.define('cat-icon-swap', BlocksIconSwap);
}
